import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { PrimaryLayout } from '../Layout';


function PrimaryTab(props) {
    var currentUser = props.oidc.user;
        const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    // const formRefs = useRef({});
    const combinedLayouts = [
        { name: 'PrimaryLayout', layout: PrimaryLayout },
    ];
    
    const updatedLayouts = combinedLayouts.map(({ name, layout }) => {
        if (name !== 'PrimaryLayout') {
            return layout.map(group => ({
                ...group,
                label: "", 
                fields: group.fields.map(field => ({
                    ...field,
                    visible: false
                }))
            }));
        }
        return layout;
    });
    
    const finalLayout = updatedLayouts.flat();
    const handlePrimaryFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad(formRefs);

    }, []);
        const handleFieldChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e,formRefs);

    }, []);
        useEffect(() => {
            if(formRefs.current['R_PROFILE'] && formRefs.current['R_PROFILE'].instance()){
                if(props.formFields.ROWID!=="00000000-0000-0000-0000-000000000000")
                    {formRefs.current['R_PROFILE'].instance().option('disabled', true);}
                else 
                 {formRefs.current['R_PROFILE'].instance().option('disabled', false);}
            }
        }, [props.formFields]);
    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='4AE9B29E-620C-45B4-8079-FF8CA53C2F11'
                layoutName='OMSalesOrderDataEntryPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
